import { type AnchorHTMLAttributes } from "react";
import { Link } from "react-router-dom";

export type LinkVariant = "primary" | "success" | "secondary" | "outline" | "danger" | "white";

export type LinkSize = "sm" | "md" | "lg";

export interface CustomLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	variant?: LinkVariant;
	size?: LinkSize;
	external?: boolean;
	state?: unknown;
}

const variantClasses: Record<LinkVariant, string> = {
	primary:
		"bg-blue-500 text-white hover:bg-blue-400 transition-colors dark:bg-blue-400 dark:text-blue-900 dark:hover:bg-blue-300 dark:hover:text-blue-900",
	success:
		"bg-emerald-500 text-white hover:bg-emerald-400 transition-colors dark:bg-emerald-400 dark:text-emerald-900 dark:hover:bg-emerald-300 dark:hover:text-emerald-900",
	secondary:
		"bg-zinc-600 text-white hover:bg-zinc-500 transition-colors dark:bg-zinc-400 dark:text-zinc-900 dark:hover:bg-zinc-300 dark:hover:text-zinc-900",
	outline:
		"bg-transparent border border-zinc-300 text-zinc-700 hover:border-zinc-400 px-2 py-1 rounded dark:border-zinc-600 dark:text-zinc-300 dark:hover:border-zinc-500",
	danger: "bg-rose-500 text-white hover:bg-rose-400 transition-colors dark:bg-rose-400 dark:text-rose-900 dark:hover:bg-rose-300 dark:hover:text-rose-900",
	white: "rounded-md bg-zinc-900 px-4 py-2 border border-zinc-900  text-white font-medium hover:bg-zinc-700 h-fit dark:bg-zinc-100 dark:text-zinc-950 dark:hover:bg-white",
};

const sizeClasses: Record<LinkSize, string> = {
	sm: "text-sm",
	md: "text-base",
	lg: "text-lg",
};

export default function CustomLink({ variant = "primary", size = "sm", className = "", external = false, ...props }: CustomLinkProps) {
	const baseStyles = "font-medium shadow-md";
	const combinedClassName = `${baseStyles} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`.trim();

	return (
		<Link
			to={props.href || "#"}
			className={combinedClassName}
			rel={external ? "noopener noreferrer" : undefined}
			target={external ? "_blank" : undefined}
			{...props}
		/>
	);
}
